<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7501_5322)">
      <path d="M23.0251 12.0234H9.00513V26.9351H23.0251V12.0234Z"
            fill="url(#paint0_linear_7501_5322)"
      />
      <path d="M8.99513 13.0459H6.00513V25.8491H8.99513V13.0459Z"
            fill="url(#paint1_linear_7501_5322)"
      />
      <path d="M8.99513 13.0459H6.00513V25.8491H8.99513V13.0459Z"
            fill="url(#paint2_linear_7501_5322)"
      />
      <path d="M14.655 13.0459H11.665V25.8491H14.655V13.0459Z"
            fill="url(#paint3_linear_7501_5322)"
      />
      <path d="M14.655 13.0459H11.665V25.8491H14.655V13.0459Z"
            fill="url(#paint4_linear_7501_5322)"
      />
      <path d="M20.3152 13.0459H17.3252V25.8491H20.3152V13.0459Z"
            fill="url(#paint5_linear_7501_5322)"
      />
      <path d="M20.3152 13.0459H17.3252V25.8491H20.3152V13.0459Z"
            fill="url(#paint6_linear_7501_5322)"
      />
      <path d="M25.9751 13.0459H22.9851V25.8491H25.9751V13.0459Z"
            fill="url(#paint7_linear_7501_5322)"
      />
      <path d="M25.9751 13.0459H22.9851V25.8491H25.9751V13.0459Z"
            fill="url(#paint8_linear_7501_5322)"
      />
      <path d="M10.0051 12.2256H5.01514V12.6802C5.01514 13.1302 5.37513 13.4902 5.82513 13.4902H9.19514C9.64514 13.4902 10.0051 13.1302 10.0051 12.6802V12.2256Z"
            fill="url(#paint9_radial_7501_5322)"
      />
      <path d="M10.0051 12.2256H5.01514V12.6802C5.01514 13.1302 5.37513 13.4902 5.82513 13.4902H9.19514C9.64514 13.4902 10.0051 13.1302 10.0051 12.6802V12.2256Z"
            fill="url(#paint10_linear_7501_5322)"
      />
      <path d="M10.0051 12.2256H5.01514V12.6802C5.01514 13.1302 5.37513 13.4902 5.82513 13.4902H9.19514C9.64514 13.4902 10.0051 13.1302 10.0051 12.6802V12.2256Z"
            fill="url(#paint11_linear_7501_5322)"
      />
      <path d="M15.655 12.2012L10.665 12.2012V12.6798C10.665 13.1298 11.025 13.4898 11.475 13.4898H14.845C15.295 13.4898 15.655 13.1298 15.655 12.6798V12.2012Z"
            fill="url(#paint12_radial_7501_5322)"
      />
      <path d="M15.655 12.2012L10.665 12.2012V12.6798C10.665 13.1298 11.025 13.4898 11.475 13.4898H14.845C15.295 13.4898 15.655 13.1298 15.655 12.6798V12.2012Z"
            fill="url(#paint13_linear_7501_5322)"
      />
      <path d="M15.655 12.2012L10.665 12.2012V12.6798C10.665 13.1298 11.025 13.4898 11.475 13.4898H14.845C15.295 13.4898 15.655 13.1298 15.655 12.6798V12.2012Z"
            fill="url(#paint14_linear_7501_5322)"
      />
      <path d="M21.325 12.2383L16.335 12.2383L16.335 12.6803C16.335 13.1303 16.695 13.4903 17.145 13.4903H20.515C20.965 13.4903 21.325 13.1303 21.325 12.6803V12.2383Z"
            fill="url(#paint15_radial_7501_5322)"
      />
      <path d="M21.325 12.2383L16.335 12.2383L16.335 12.6803C16.335 13.1303 16.695 13.4903 17.145 13.4903H20.515C20.965 13.4903 21.325 13.1303 21.325 12.6803V12.2383Z"
            fill="url(#paint16_linear_7501_5322)"
      />
      <path d="M21.325 12.2383L16.335 12.2383L16.335 12.6803C16.335 13.1303 16.695 13.4903 17.145 13.4903H20.515C20.965 13.4903 21.325 13.1303 21.325 12.6803V12.2383Z"
            fill="url(#paint17_linear_7501_5322)"
      />
      <path d="M26.9851 12.2392H21.9951V12.6798C21.9951 13.1298 22.3551 13.4898 22.8051 13.4898H26.1751C26.6251 13.4898 26.9851 13.1298 26.9851 12.6798V12.2392Z"
            fill="url(#paint18_radial_7501_5322)"
      />
      <path d="M26.9851 12.2392H21.9951V12.6798C21.9951 13.1298 22.3551 13.4898 22.8051 13.4898H26.1751C26.6251 13.4898 26.9851 13.1298 26.9851 12.6798V12.2392Z"
            fill="url(#paint19_linear_7501_5322)"
      />
      <path d="M26.9851 12.2392H21.9951V12.6798C21.9951 13.1298 22.3551 13.4898 22.8051 13.4898H26.1751C26.6251 13.4898 26.9851 13.1298 26.9851 12.6798V12.2392Z"
            fill="url(#paint20_linear_7501_5322)"
      />
      <path d="M4.03516 9.93994H27.9952V11.8601C27.9952 12.2101 27.7152 12.4901 27.3652 12.4901H4.66516C4.31516 12.4901 4.03516 12.2101 4.03516 11.8601V10.4901V9.93994Z"
            fill="#B8B1C0"
      />
      <path d="M4.03516 9.93994H27.9952V11.8601C27.9952 12.2101 27.7152 12.4901 27.3652 12.4901H4.66516C4.31516 12.4901 4.03516 12.2101 4.03516 11.8601V10.4901V9.93994Z"
            fill="url(#paint21_linear_7501_5322)"
      />
      <path d="M4.03516 9.93994H27.9952V11.8601C27.9952 12.2101 27.7152 12.4901 27.3652 12.4901H4.66516C4.31516 12.4901 4.03516 12.2101 4.03516 11.8601V10.4901V9.93994Z"
            fill="url(#paint22_linear_7501_5322)"
      />
      <path d="M4.03516 9.93994H27.9952V11.8601C27.9952 12.2101 27.7152 12.4901 27.3652 12.4901H4.66516C4.31516 12.4901 4.03516 12.2101 4.03516 11.8601V10.4901V9.93994Z"
            fill="url(#paint23_linear_7501_5322)"
      />
      <path d="M15.3263 3.01008L3.36628 9.75008C3.00628 9.95008 3.14628 10.5101 3.56628 10.5101H28.4463C28.8663 10.5101 29.0063 9.96008 28.6463 9.75008L16.6863 3.01008C16.2663 2.77008 15.7463 2.77008 15.3263 3.01008Z"
            fill="url(#paint24_linear_7501_5322)"
      />
      <path d="M15.3263 3.01008L3.36628 9.75008C3.00628 9.95008 3.14628 10.5101 3.56628 10.5101H28.4463C28.8663 10.5101 29.0063 9.96008 28.6463 9.75008L16.6863 3.01008C16.2663 2.77008 15.7463 2.77008 15.3263 3.01008Z"
            fill="url(#paint25_linear_7501_5322)"
      />
      <path d="M15.3263 3.01008L3.36628 9.75008C3.00628 9.95008 3.14628 10.5101 3.56628 10.5101H28.4463C28.8663 10.5101 29.0063 9.96008 28.6463 9.75008L16.6863 3.01008C16.2663 2.77008 15.7463 2.77008 15.3263 3.01008Z"
            fill="url(#paint26_linear_7501_5322)"
      />
      <path d="M15.3263 3.01008L3.36628 9.75008C3.00628 9.95008 3.14628 10.5101 3.56628 10.5101H28.4463C28.8663 10.5101 29.0063 9.96008 28.6463 9.75008L16.6863 3.01008C16.2663 2.77008 15.7463 2.77008 15.3263 3.01008Z"
            fill="url(#paint27_linear_7501_5322)"
      />
      <path d="M21.9851 26.6783H26.9751V26.29C26.9751 25.84 26.6151 25.48 26.1651 25.48H22.7951C22.3451 25.48 21.9851 25.84 21.9851 26.29V26.6783Z"
            fill="url(#paint28_radial_7501_5322)"
      />
      <path d="M21.9851 26.6783H26.9751V26.29C26.9751 25.84 26.6151 25.48 26.1651 25.48H22.7951C22.3451 25.48 21.9851 25.84 21.9851 26.29V26.6783Z"
            fill="url(#paint29_linear_7501_5322)"
      />
      <path d="M21.9851 26.6783H26.9751V26.29C26.9751 25.84 26.6151 25.48 26.1651 25.48H22.7951C22.3451 25.48 21.9851 25.84 21.9851 26.29V26.6783Z"
            fill="url(#paint30_linear_7501_5322)"
      />
      <path d="M16.335 26.48V26.6591H21.325V26.29C21.325 25.84 20.965 25.48 20.515 25.48H17.145C16.695 25.48 16.335 25.84 16.335 26.29V26.48Z"
            fill="url(#paint31_radial_7501_5322)"
      />
      <path d="M16.335 26.48V26.6591H21.325V26.29C21.325 25.84 20.965 25.48 20.515 25.48H17.145C16.695 25.48 16.335 25.84 16.335 26.29V26.48Z"
            fill="url(#paint32_linear_7501_5322)"
      />
      <path d="M16.335 26.48V26.6591H21.325V26.29C21.325 25.84 20.965 25.48 20.515 25.48H17.145C16.695 25.48 16.335 25.84 16.335 26.29V26.48Z"
            fill="url(#paint33_linear_7501_5322)"
      />
      <path d="M10.665 26.6542H15.655V26.29C15.655 25.84 15.295 25.48 14.845 25.48H11.475C11.025 25.48 10.665 25.84 10.665 26.29V26.6542Z"
            fill="url(#paint34_radial_7501_5322)"
      />
      <path d="M10.665 26.6542H15.655V26.29C15.655 25.84 15.295 25.48 14.845 25.48H11.475C11.025 25.48 10.665 25.84 10.665 26.29V26.6542Z"
            fill="url(#paint35_linear_7501_5322)"
      />
      <path d="M10.665 26.6542H15.655V26.29C15.655 25.84 15.295 25.48 14.845 25.48H11.475C11.025 25.48 10.665 25.84 10.665 26.29V26.6542Z"
            fill="url(#paint36_linear_7501_5322)"
      />
      <path d="M5.00513 26.666H9.99513V26.29C9.99513 25.84 9.63512 25.48 9.18512 25.48H5.81512C5.36512 25.48 5.00513 25.84 5.00513 26.29V26.666Z"
            fill="url(#paint37_radial_7501_5322)"
      />
      <path d="M5.00513 26.666H9.99513V26.29C9.99513 25.84 9.63512 25.48 9.18512 25.48H5.81512C5.36512 25.48 5.00513 25.84 5.00513 26.29V26.666Z"
            fill="url(#paint38_linear_7501_5322)"
      />
      <path d="M5.00513 26.666H9.99513V26.29C9.99513 25.84 9.63512 25.48 9.18512 25.48H5.81512C5.36512 25.48 5.00513 25.84 5.00513 26.29V26.666Z"
            fill="url(#paint39_linear_7501_5322)"
      />
      <path d="M28.7751 9.67L16.2551 2.56C16.1751 2.52 16.0951 2.5 16.0051 2.5C15.9251 2.5 15.8351 2.52 15.7551 2.56L3.23505 9.67C3.01505 9.8 2.93505 10.07 3.06505 10.29C3.15505 10.43 3.30505 10.51 3.46505 10.51C3.54505 10.51 3.62505 10.49 3.70505 10.45L15.7751 3.6C15.9151 3.52 16.0951 3.52 16.2351 3.6L28.3051 10.45C28.3751 10.49 28.465 10.51 28.545 10.51C28.705 10.51 28.8651 10.43 28.9451 10.29C29.0751 10.07 29.0051 9.79 28.7751 9.67Z"
            fill="url(#paint40_linear_7501_5322)"
      />
      <path d="M28.7751 9.67L16.2551 2.56C16.1751 2.52 16.0951 2.5 16.0051 2.5C15.9251 2.5 15.8351 2.52 15.7551 2.56L3.23505 9.67C3.01505 9.8 2.93505 10.07 3.06505 10.29C3.15505 10.43 3.30505 10.51 3.46505 10.51C3.54505 10.51 3.62505 10.49 3.70505 10.45L15.7751 3.6C15.9151 3.52 16.0951 3.52 16.2351 3.6L28.3051 10.45C28.3751 10.49 28.465 10.51 28.545 10.51C28.705 10.51 28.8651 10.43 28.9451 10.29C29.0751 10.07 29.0051 9.79 28.7751 9.67Z"
            fill="url(#paint41_linear_7501_5322)"
      />
      <path d="M28.7751 9.67L16.2551 2.56C16.1751 2.52 16.0951 2.5 16.0051 2.5C15.9251 2.5 15.8351 2.52 15.7551 2.56L3.23505 9.67C3.01505 9.8 2.93505 10.07 3.06505 10.29C3.15505 10.43 3.30505 10.51 3.46505 10.51C3.54505 10.51 3.62505 10.49 3.70505 10.45L15.7751 3.6C15.9151 3.52 16.0951 3.52 16.2351 3.6L28.3051 10.45C28.3751 10.49 28.465 10.51 28.545 10.51C28.705 10.51 28.8651 10.43 28.9451 10.29C29.0751 10.07 29.0051 9.79 28.7751 9.67Z"
            fill="url(#paint42_linear_7501_5322)"
      />
      <path d="M28.9649 29.4697H3.0249V27.0997C3.0249 26.7497 3.30489 26.4697 3.65489 26.4697H28.3449C28.6949 26.4697 28.9749 26.7497 28.9749 27.0997V29.4697H28.9649Z"
            fill="#B9B4C3"
      />
      <path d="M28.9649 29.4697H3.0249V27.0997C3.0249 26.7497 3.30489 26.4697 3.65489 26.4697H28.3449C28.6949 26.4697 28.9749 26.7497 28.9749 27.0997V29.4697H28.9649Z"
            fill="url(#paint43_linear_7501_5322)"
      />
      <path d="M28.9649 29.4697H3.0249V27.0997C3.0249 26.7497 3.30489 26.4697 3.65489 26.4697H28.3449C28.6949 26.4697 28.9749 26.7497 28.9749 27.0997V29.4697H28.9649Z"
            fill="url(#paint44_linear_7501_5322)"
      />
      <path d="M28.9649 29.4697H3.0249V27.0997C3.0249 26.7497 3.30489 26.4697 3.65489 26.4697H28.3449C28.6949 26.4697 28.9749 26.7497 28.9749 27.0997V29.4697H28.9649Z"
            fill="url(#paint45_linear_7501_5322)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7501_5322"
                      x1="16.5028"
                      y1="11.1664"
                      x2="16.5028"
                      y2="26.9351"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#35303B" />
        <stop offset="1"
              stop-color="#65527A"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7501_5322"
                      x1="6.00613"
                      y1="19.4489"
                      x2="9.43245"
                      y2="19.4489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#817C86" />
        <stop offset="0.572917"
              stop-color="#CFC7D7"
        />
        <stop offset="0.67166"
              stop-color="#CFC7D7"
        />
        <stop offset="1"
              stop-color="#9A94A1"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7501_5322"
                      x1="7.50013"
                      y1="12.7907"
                      x2="7.50013"
                      y2="14.0161"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.390359"
              stop-color="#71677D"
        />
        <stop offset="1"
              stop-color="#71677D"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_7501_5322"
                      x1="11.666"
                      y1="19.4489"
                      x2="15.0923"
                      y2="19.4489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7B7681" />
        <stop offset="0.572917"
              stop-color="#BFB9C8"
        />
        <stop offset="0.67166"
              stop-color="#BFB9C8"
        />
        <stop offset="1"
              stop-color="#B2ABB8"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_7501_5322"
                      x1="13.16"
                      y1="12.7907"
                      x2="13.16"
                      y2="14.0161"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.390359"
              stop-color="#71677D"
        />
        <stop offset="1"
              stop-color="#71677D"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7501_5322"
                      x1="17.3262"
                      y1="19.4489"
                      x2="20.7525"
                      y2="19.4489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6E6A73" />
        <stop offset="0.572917"
              stop-color="#CBC3D3"
        />
        <stop offset="0.67166"
              stop-color="#CBC3D3"
        />
        <stop offset="1"
              stop-color="#BFB9C5"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_7501_5322"
                      x1="18.8202"
                      y1="12.7907"
                      x2="18.8202"
                      y2="14.0161"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.390359"
              stop-color="#71677D"
        />
        <stop offset="1"
              stop-color="#71677D"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint7_linear_7501_5322"
                      x1="22.9861"
                      y1="19.4489"
                      x2="26.4124"
                      y2="19.4489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#615E6A" />
        <stop offset="0.572917"
              stop-color="#DAD2E2"
        />
        <stop offset="0.67166"
              stop-color="#DCD4E4"
        />
        <stop offset="1"
              stop-color="#D5CDDC"
        />
      </linearGradient>
      <linearGradient id="paint8_linear_7501_5322"
                      x1="24.4801"
                      y1="12.7907"
                      x2="24.4801"
                      y2="14.0161"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.390359"
              stop-color="#71677D"
        />
        <stop offset="1"
              stop-color="#71677D"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint9_radial_7501_5322"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.79671 12.9933) rotate(180) scale(3.24521 0.936996)"
      >
        <stop stop-color="#91899D" />
        <stop offset="1"
              stop-color="#6D6976"
        />
      </radialGradient>
      <linearGradient id="paint10_linear_7501_5322"
                      x1="7.51014"
                      y1="12.1804"
                      x2="7.51014"
                      y2="12.7607"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop offset="1"
              stop-color="#564F5E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_7501_5322"
                      x1="7.51014"
                      y1="13.7708"
                      x2="7.51014"
                      y2="13.298"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop offset="1"
              stop-color="#564F5E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint12_radial_7501_5322"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.4466 12.993) rotate(180) scale(3.2452 0.936996)"
      >
        <stop stop-color="#91899D" />
        <stop offset="1"
              stop-color="#6D6976"
        />
      </radialGradient>
      <linearGradient id="paint13_linear_7501_5322"
                      x1="13.16"
                      y1="12.1801"
                      x2="13.16"
                      y2="12.7603"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop offset="1"
              stop-color="#564F5E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_7501_5322"
                      x1="13.16"
                      y1="13.7704"
                      x2="13.16"
                      y2="13.2976"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop offset="1"
              stop-color="#564F5E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint15_radial_7501_5322"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.1165 12.9934) rotate(180) scale(3.2452 0.936996)"
      >
        <stop stop-color="#91899D" />
        <stop offset="1"
              stop-color="#6D6976"
        />
      </radialGradient>
      <linearGradient id="paint16_linear_7501_5322"
                      x1="18.83"
                      y1="12.1805"
                      x2="18.83"
                      y2="12.7608"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop offset="1"
              stop-color="#564F5E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint17_linear_7501_5322"
                      x1="18.83"
                      y1="13.7709"
                      x2="18.83"
                      y2="13.2981"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop offset="1"
              stop-color="#564F5E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint18_radial_7501_5322"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.7767 12.9929) rotate(180) scale(3.2452 0.936996)"
      >
        <stop stop-color="#91899D" />
        <stop offset="1"
              stop-color="#6D6976"
        />
      </radialGradient>
      <linearGradient id="paint19_linear_7501_5322"
                      x1="24.4901"
                      y1="12.18"
                      x2="24.4901"
                      y2="12.7603"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop offset="1"
              stop-color="#564F5E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint20_linear_7501_5322"
                      x1="24.4901"
                      y1="13.7704"
                      x2="24.4901"
                      y2="13.2976"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop offset="1"
              stop-color="#564F5E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint21_linear_7501_5322"
                      x1="27.9952"
                      y1="12.49"
                      x2="27.3586"
                      y2="12.49"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E8DFEF" />
        <stop offset="1"
              stop-color="#E8DFEF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint22_linear_7501_5322"
                      x1="16.0152"
                      y1="12.7328"
                      x2="16.0152"
                      y2="11.8984"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#726483" />
        <stop offset="1"
              stop-color="#726483"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint23_linear_7501_5322"
                      x1="3.88564"
                      y1="12.4901"
                      x2="4.76064"
                      y2="12.4901"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#706D76" />
        <stop offset="1"
              stop-color="#706D76"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint24_linear_7501_5322"
                      x1="19.8711"
                      y1="4.38499"
                      x2="16.0063"
                      y2="11.0725"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3ACBB" />
        <stop offset="1"
              stop-color="#ACA5B2"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7501_5322"
                      x1="20.4492"
                      y1="5.85374"
                      x2="20.0899"
                      y2="6.47875"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#645A6F" />
        <stop offset="1"
              stop-color="#645A6F"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7501_5322"
                      x1="16.0063"
                      y1="11.0633"
                      x2="16.0063"
                      y2="10.3618"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#878190" />
        <stop offset="1"
              stop-color="#878190"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint27_linear_7501_5322"
                      x1="11.87"
                      y1="5.53132"
                      x2="12.0731"
                      y2="5.89069"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.344727"
              stop-color="#857F8E"
        />
        <stop offset="1"
              stop-color="#857F8E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint28_radial_7501_5322"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.5614 25.9761) rotate(180) scale(2.58035 0.668458)"
      >
        <stop stop-color="#F7EDFD" />
        <stop offset="1"
              stop-color="#A29CA7"
        />
      </radialGradient>
      <linearGradient id="paint29_linear_7501_5322"
                      x1="22.9606"
                      y1="27.3512"
                      x2="23.8189"
                      y2="25.7776"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#656067" />
        <stop offset="1"
              stop-color="#656067"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint30_linear_7501_5322"
                      x1="27.6312"
                      y1="26.1562"
                      x2="26.3187"
                      y2="26.48"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#807C87" />
        <stop offset="1"
              stop-color="#807C87"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint31_radial_7501_5322"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.9113 25.9761) rotate(180) scale(2.58035 0.668459)"
      >
        <stop stop-color="#E4DAEA" />
        <stop offset="1"
              stop-color="#9A949E"
        />
      </radialGradient>
      <linearGradient id="paint32_linear_7501_5322"
                      x1="17.3105"
                      y1="27.3512"
                      x2="18.1688"
                      y2="25.7776"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#656067" />
        <stop offset="1"
              stop-color="#656067"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint33_linear_7501_5322"
                      x1="21.981"
                      y1="26.1562"
                      x2="20.6685"
                      y2="26.48"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#807C87" />
        <stop offset="1"
              stop-color="#807C87"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint34_radial_7501_5322"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.2413 25.9761) rotate(180) scale(2.58035 0.668458)"
      >
        <stop stop-color="#E4DAEA" />
        <stop offset="1"
              stop-color="#9A949E"
        />
      </radialGradient>
      <linearGradient id="paint35_linear_7501_5322"
                      x1="11.6406"
                      y1="27.3512"
                      x2="12.4988"
                      y2="25.7776"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#656067" />
        <stop offset="1"
              stop-color="#656067"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint36_linear_7501_5322"
                      x1="16.3111"
                      y1="26.1562"
                      x2="14.9986"
                      y2="26.48"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#807C87" />
        <stop offset="1"
              stop-color="#807C87"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint37_radial_7501_5322"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.58144 25.9761) rotate(180) scale(2.58035 0.668458)"
      >
        <stop stop-color="#E4DAEA" />
        <stop offset="1"
              stop-color="#9A949E"
        />
      </radialGradient>
      <linearGradient id="paint38_linear_7501_5322"
                      x1="5.98065"
                      y1="27.3512"
                      x2="6.83894"
                      y2="25.7776"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#656067" />
        <stop offset="1"
              stop-color="#656067"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint39_linear_7501_5322"
                      x1="10.6512"
                      y1="26.1562"
                      x2="9.3387"
                      y2="26.48"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#807C87" />
        <stop offset="1"
              stop-color="#807C87"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint40_linear_7501_5322"
                      x1="26.3806"
                      y1="8.53315"
                      x2="4.55145"
                      y2="8.53315"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADA7B8" />
        <stop offset="1"
              stop-color="#9F99A4"
        />
      </linearGradient>
      <linearGradient id="paint41_linear_7501_5322"
                      x1="19.8355"
                      y1="4.42878"
                      x2="17.1864"
                      y2="9.09065"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A9A3B1" />
        <stop offset="0.0965298"
              stop-color="#CFC6D6"
              stop-opacity="0.85"
        />
        <stop offset="0.176002"
              stop-color="#857D92"
        />
        <stop offset="1"
              stop-color="#857D92"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint42_linear_7501_5322"
                      x1="12.1771"
                      y1="4.42878"
                      x2="14.8262"
                      y2="9.09065"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A9A3B1" />
        <stop offset="0.0965298"
              stop-color="#CFC6D6"
              stop-opacity="0.85"
        />
        <stop offset="0.176002"
              stop-color="#857D92"
        />
        <stop offset="1"
              stop-color="#857D92"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint43_linear_7501_5322"
                      x1="28.9749"
                      y1="27.9697"
                      x2="28.3383"
                      y2="27.9697"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E8DFEF" />
        <stop offset="1"
              stop-color="#E8DFEF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint44_linear_7501_5322"
                      x1="15.9949"
                      y1="28.2125"
                      x2="15.9949"
                      y2="27.378"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#726483" />
        <stop offset="1"
              stop-color="#726483"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint45_linear_7501_5322"
                      x1="3.86537"
                      y1="27.9697"
                      x2="4.74037"
                      y2="27.9697"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#706D76" />
        <stop offset="1"
              stop-color="#706D76"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_7501_5322">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>